var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrinityRoundIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2475,
    height: 2475,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 974,
    y: 66,
    width: 2475,
    height: 2475
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 800793,
    cy: 799407,
    r: 1131513,
    fx: 800793,
    fy: 799408,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad",
    id: "fill1",
    gradientTransform: "matrix(2.20983e-20 0.000360892 -0.000360892 2.20983e-20 2500 1040)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E97132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E97132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C00000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-974 -66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M974 1303.5C974 620.048 1528.05 66 2211.5 66 2894.95 66 3449 620.048 3449 1303.5 3449 1986.95 2894.95 2541 2211.5 2541 1528.05 2541 974 1986.95 974 1303.5Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2476 1082.4C2476 1115.18 2475.54 1147.56 2474.64 1179.48L2474.49 1183 2470.64 1092.26C2446.02 659.63 2339.58 334.191 2212 334.191 2084.42 334.191 1977.98 659.63 1953.36 1092.26L1949.51 1183 1949.36 1179.48C1948.46 1147.56 1948 1115.18 1948 1082.4 1948 558.063 2066.2 133 2212 133 2357.8 133 2476 558.063 2476 1082.4Z",
    fill: "#E97132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2211.5 1040C2370.83 1040 2500 1169.39 2500 1329 2500 1488.61 2370.83 1618 2211.5 1618 2052.17 1618 1923 1488.61 1923 1329 1923 1169.39 2052.17 1040 2211.5 1040Z",
    fill: "url(#fill1)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1870.83 1217.6C1899.22 1201.21 1927.51 1185.41 1955.61 1170.23L1958.73 1168.59 1882.05 1217.31C1519.59 1455.01 1290.9 1709.95 1354.68 1820.44 1418.47 1930.92 1753.61 1860.34 2140.69 1665.29L2221.22 1623.24 2218.24 1625.13C2191.05 1641.87 2163.22 1658.47 2134.83 1674.86 1680.62 1937.1 1253.3 2047.33 1180.4 1921.06 1107.5 1794.79 1416.62 1479.84 1870.83 1217.6Z",
    fill: "#E97132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2288.49 1674.86C2260.11 1658.47 2232.28 1641.87 2205.09 1625.13L2202.11 1623.24 2282.64 1665.29C2669.72 1860.34 3004.86 1930.92 3068.64 1820.44 3132.43 1709.95 2903.74 1455.01 2541.28 1217.31L2464.6 1168.59 2467.72 1170.23C2495.82 1185.41 2524.11 1201.21 2552.49 1217.6 3006.71 1479.84 3315.83 1794.79 3242.93 1921.06 3170.03 2047.33 2742.71 1937.1 2288.49 1674.86Z",
    fill: "#E97132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2213.51 1304.17C2245.76 1304.17 2271.91 1315.51 2271.91 1329.5 2271.91 1343.49 2245.76 1354.83 2213.51 1354.83 2181.26 1354.83 2155.12 1343.49 2155.12 1329.5 2155.12 1315.51 2181.26 1304.17 2213.51 1304.17ZM2264.15 1291C2268.99 1291 2273.77 1291.07 2278.48 1291.2L2279 1291.22 2265.6 1291.78C2201.74 1295.37 2153.7 1310.9 2153.7 1329.5 2153.7 1348.11 2201.74 1363.63 2265.6 1367.22L2279 1367.78 2278.48 1367.8C2273.77 1367.93 2268.99 1368 2264.15 1368 2186.75 1368 2124 1350.76 2124 1329.5 2124 1308.24 2186.75 1291 2264.15 1291Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2504.3 1930.63 2562.17 1930.63 2601.26 2036.38 2640.04 1930.63 2696.1 1930.63 2590.05 2180 2534.3 2180 2573.08 2093.95ZM2311.39 1930.63 2363.2 1930.63 2363.2 2099.7 2311.39 2099.7ZM2018.39 1930.63 2070.2 1930.63 2070.2 2099.7 2018.39 2099.7ZM2210.41 1928.81C2230.2 1928.81 2246.01 1935.22 2257.83 1948.05 2269.64 1960.88 2275.55 1978.5 2275.55 2000.93L2275.55 2099.7 2224.04 2099.7 2224.04 2007.89C2224.04 1996.58 2221.11 1987.8 2215.26 1981.53 2209.4 1975.27 2201.52 1972.14 2191.62 1972.14 2181.72 1972.14 2173.85 1975.27 2167.99 1981.53 2162.13 1987.8 2159.2 1996.58 2159.2 2007.89L2159.2 2099.7 2107.39 2099.7 2107.39 1930.63 2159.2 1930.63 2159.2 1953.05C2164.45 1945.58 2171.52 1939.67 2180.41 1935.33 2189.3 1930.98 2199.3 1928.81 2210.41 1928.81ZM1994.23 1928.81 1994.23 1983.65 1979.99 1983.65C1967.06 1983.65 1957.36 1986.43 1950.9 1991.99 1944.43 1997.54 1941.2 2007.29 1941.2 2021.23L1941.2 2099.7 1889.39 2099.7 1889.39 1930.63 1941.2 1930.63 1941.2 1958.81C1947.26 1949.52 1954.84 1942.19 1963.93 1936.84 1973.02 1931.49 1983.12 1928.81 1994.23 1928.81ZM2409.57 1889.42 2461.38 1889.42 2461.38 1930.63 2495.32 1930.63 2495.32 1973.66 2461.38 1973.66 2461.38 2041.53C2461.38 2046.58 2462.59 2050.21 2465.02 2052.44 2467.44 2054.66 2471.48 2055.77 2477.14 2055.77L2495.62 2055.77 2495.62 2099.7 2469.26 2099.7C2450.47 2099.7 2435.83 2095.11 2425.33 2085.92 2414.82 2076.73 2409.57 2061.73 2409.57 2040.92L2409.57 1973.66 2388.97 1973.66 2388.97 1930.63 2409.57 1930.63ZM1774.57 1889.42 1826.38 1889.42 1826.38 1930.63 1860.32 1930.63 1860.32 1973.66 1826.38 1973.66 1826.38 2041.53C1826.38 2046.58 1827.59 2050.21 1830.02 2052.44 1832.44 2054.66 1836.48 2055.77 1842.14 2055.77L1860.62 2055.77 1860.62 2099.7 1834.26 2099.7C1815.47 2099.7 1800.83 2095.11 1790.33 2085.92 1779.82 2076.73 1774.57 2061.73 1774.57 2040.92L1774.57 1973.66 1753.97 1973.66 1753.97 1930.63 1774.57 1930.63ZM2337.45 1857C2346.33 1857 2353.66 1859.68 2359.41 1865.03 2365.17 1870.38 2368.05 1877.1 2368.05 1885.18 2368.05 1893.06 2365.17 1899.67 2359.41 1905.03 2353.66 1910.38 2346.33 1913.06 2337.45 1913.06 2328.36 1913.06 2320.93 1910.38 2315.18 1905.03 2309.42 1899.67 2306.54 1893.06 2306.54 1885.18 2306.54 1877.1 2309.42 1870.38 2315.18 1865.03 2320.93 1859.68 2328.36 1857 2337.45 1857ZM2044.45 1857C2053.33 1857 2060.66 1859.68 2066.41 1865.03 2072.17 1870.38 2075.05 1877.1 2075.05 1885.18 2075.05 1893.06 2072.17 1899.67 2066.41 1905.03 2060.66 1910.38 2053.33 1913.06 2044.45 1913.06 2035.36 1913.06 2027.93 1910.38 2022.18 1905.03 2016.42 1899.67 2013.54 1893.06 2013.54 1885.18 2013.54 1877.1 2016.42 1870.38 2022.18 1865.03 2027.93 1859.68 2035.36 1857 2044.45 1857Z",
    stroke: "#E97132",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#E97132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 0,
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontSize: 322.998,
    x: 1753.97,
    y: 2139.62
  }, "trinity"), /*#__PURE__*/React.createElement("text", {
    fill: "#F2F2F2",
    fontFamily: "Poppins,Poppins_MSFontService,sans-serif",
    fontStyle: "italic",
    fontWeight: 400,
    fontSize: 52,
    transform: "matrix(1 0 0 1 1581.74 2269)"
  }, "the superpower for tech services growth creators"), /*#__PURE__*/React.createElement("text", {
    fill: "#E97132",
    fontFamily: "Poppins,Poppins_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 83,
    transform: "matrix(1 0 0 1 2323.88 200)"
  }, "\u2122"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrinityRoundIcon1);
export default __webpack_public_path__ + "static/media/trinityRoundIcon1.fb97fdf03a5b2faef5073f4aa2c4fe28.svg";
export { ForwardRef as ReactComponent };